/**
 * Chat page route — eagerly registers the file route; the chat interface
 * component (`ChatLayout` + the conversation atoms/RPC clients it pulls in) is
 * deferred to `chat.lazy.tsx` so it loads only on this route, never in the
 * always-loaded `main` chunk (CLA-645).
 *
 * This is a protected route (inherits auth from the `_authenticated` layout).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/flirtmachine/_authenticated/chat")({});
